/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useEffect } from 'react';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import IEnergyManagementProps from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import UtilityBillPerformanceDetailComponent from '../../UtilityBillPerformanceDetailWidget/UtilityBillPerformanceDetailWidget';
import SavingsByMeterComponent from '../../SavingsByMeterWidget/SavingsByMeterComponent';
import useConnectorAndDynamicProps from '../../../shared/useConnectorAndDynamicProps/useConnectorAndDynamicProps';
import useMounted from '../../../shared/useMount/useMount';
import {
  excludeCurrentMonth,
  getFirstDayofSelectedMonth
} from '../../../shared/Utils/Utils';
import { UtilityType } from '../../../shared/Utils/Constants';
import { getConnctorConfig } from '../../../shared/Utils/DataConnectorUtils';

const SolarSavingsDetailComponent = (props: IEnergyManagementProps) => {
  const { bearerToken, requestContext } = props;

  const startTime = getFirstDayofSelectedMonth(
    requestContext.context.startTime!
  );
  const endTime = excludeCurrentMonth(
    requestContext.context.endTime!,
    requestContext.context.startTime!
  );

  const isMounted = useMounted();

  const connectorConfig = getConnctorConfig(
    'utility-sewerage',
    requestContext,
    startTime,
    endTime
  );

  const [dataConnector] = useConnectorAndDynamicProps({
    connectorConfig,
    requestContext,
    bearerToken
  });

  useEffect(() => {
    if (isMounted) {
      dataConnector && dataConnector.actions && dataConnector.actions.getAll();
    }
  }, [requestContext]);
  const [t] = useTranslation();
  const d = descriptors.energyManagement;
  const commonProps = {
    performanceHeading: t(d.SOLARPERFORMANCE)
  };

  return (
    <div>
      <UtilityBillPerformanceDetailComponent
        dataConnector={dataConnector}
        commonProps={commonProps}
      />
      <SavingsByMeterComponent
        dataConnector={dataConnector}
        UtilityBillType={UtilityType.Sewerage}
      />
    </div>
  );
};
export default SolarSavingsDetailComponent;
